module.exports = __webpack_public_path__ + "fonts/Nunito-MediumItalic.88aa4a1f.ttf";